import { Injectable } from '@angular/core';
import { User } from '../types';
//import { Headers, Response, Http, RequestOptions } from '@angular/http';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Rx'
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class UserService {
  private usersUrl = 'api/users';

  constructor(private http: HttpClient) { }

  getUsers(letter : string): Observable<User[]> {
    const url = `api/users/${letter}`;
    return this.http.get<User[]>(url)
      //.map((res:Response) => res.json())
      .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  getUser(userid: number): Observable<User> {
    const url = `api/user/${userid}`;
    return this.http.get<User>(url)
      //.map((res:Response) => res.json())
      .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  upsertUser(user: User): Observable<any> {
    const url = `api/user/${user.UserId}`;
    //let bodyString = JSON.stringify(user); // Stringify payload
    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", "application/json"); // ... Set content type to JSON
    return this.http.post(url, user, { headers: headers }) // ...using put request
      .catch((error: any) => Observable.throw(error.error || 'Server error')); //...errors if any

  }
}
